import './GrafSubestacion.css';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function GrafSubestacion() {
    const { t } = useTranslation();
    // Estados para las fechas seleccionadas
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    // Estados para las fechas confirmadas
    const [confirmedStartDate, setConfirmedStartDate] = useState('');
    const [confirmedEndDate, setConfirmedEndDate] = useState('');

    // Función para convertir la fecha a milisegundos
    const dateToMilliseconds = (date) => {
        return new Date(date).getTime();
    };

    // URLs de los paneles con las fechas confirmadas en milisegundos
    const from = confirmedStartDate ? dateToMilliseconds(confirmedStartDate) : 'now-720m';
    const to = confirmedEndDate ? dateToMilliseconds(confirmedEndDate) : 'now';

    // Función para confirmar las fechas seleccionadas
    const handleConfirm = () => {
        setConfirmedStartDate(startDate);
        setConfirmedEndDate(endDate);
    };

    // Función para resetear las fechas a valores predeterminados
    const handleReset = () => {
        setStartDate('');
        setEndDate('');
        setConfirmedStartDate('');
        setConfirmedEndDate('');
    };

    return (
        <>
            <div className="container-fluid">
                {/* Selección de fechas */}
                <div className="row mb-3">
                    <div className="col col-3">
                        <label>{t('scada.solarFarm.historical.startDate')}&nbsp;</label>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </div>
                    <div className="col col-3">
                        <label>{t('scada.solarFarm.historical.endDate')}&nbsp;</label>
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                    <div className="col col-3 d-flex align-items-end">
                        <button onClick={handleConfirm} className="btn btn-primary me-2">{t('scada.solarFarm.historical.confirm')}</button>
                        <button onClick={handleReset} className="btn btn-secondary">{t('scada.solarFarm.historical.reset')}</button>
                    </div>
                </div>

                {/* Gráficos */}
                <div className="row">
                    <div className="col col-6">
                        <object data={`https://eurus.energynebula.com/grafana/d-solo/eWIHfzWNz/scada-solar-set?orgId=1&theme=light&refresh=1m&panelId=4&from=${from}&to=${to}`} width="100%" height="400" frameBorder="0"></object>
                    </div>
                    <div className="col col-6">
                        <object data={`https://eurus.energynebula.com/grafana/d-solo/eWIHfzWNz/scada-solar-set?orgId=1&theme=light&refresh=1m&panelId=6&from=${from}&to=${to}`} width="100%" height="400" frameBorder="0"></object>
                    </div>
                </div>
                <div className="row">
                    <div className="col col-6">
                        <object data={`https://eurus.energynebula.com/grafana/d-solo/eWIHfzWNz/scada-solar-set?orgId=1&theme=light&refresh=1m&panelId=2&from=${from}&to=${to}`} width="100%" height="400" frameBorder="0"></object>
                    </div>
                    <div className="col col-6">
                        <object data={`https://eurus.energynebula.com/grafana/d-solo/eWIHfzWNz/scada-solar-set?orgId=1&theme=light&refresh=1m&panelId=7&from=${from}&to=${to}`} width="100%" height="400" frameBorder="0"></object>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GrafSubestacion;
